function trimTrailingSlash(value) {
  return String(value || '').trim().replace(/\/+$/, '');
}

function currentOrigin() {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}

const DEFAULT_INTERVIEWEE_APP_URL = 'https://interview.trypareto.ai';

export const appConfig = {
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL),
  careerAppUrl: trimTrailingSlash(import.meta.env.VITE_CAREER_APP_URL) || currentOrigin(),
  intervieweeAppUrl: trimTrailingSlash(import.meta.env.VITE_INTERVIEWEE_APP_URL) || DEFAULT_INTERVIEWEE_APP_URL,
  landingUrl: trimTrailingSlash(import.meta.env.VITE_LANDING_URL),
};

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${appConfig.apiBaseUrl}${normalizedPath}`;
}
